import { ACTIVE } from "@api/services/investments/shapes/InvestmentStatusEnum"
import { indexProjectInvestmentsOperation } from "@api/services/investments"

const listProjectInvestments = async (request, projectId) => {
  const { data: projectInvestments } = await request(indexProjectInvestmentsOperation, { projectId })

  // NOTE: Consider only active investments for transfer.
  const activeInvestments = projectInvestments
    .filter(({ status }) => status === ACTIVE)

  return activeInvestments
}

export default listProjectInvestments
